<div class="margin-container" [class.hidden]="hidden">
  <div class="form-wrapper" [ngClass]="{ readonly: readonly }">
    @if (label) {
      <div class="ion-text-start label" [class.error]="showError && control?.errors">
        {{ label }}
      </div>
    }
    <div class="wrapper"
      [class.error]="showError && control?.errors" [id]="'open-modal-' + id">
      <div class="placeholder">
        @if (showPrefixContent) {
          <div>
            <ng-content #prefixContent></ng-content>
          </div>
        }
        <div class="value">{{ displayedValue$ | async }}</div>
        @if (loading) {
          <c-spinner [loading]="loading"></c-spinner>
        } @else {
          @if (!readonly) {
            <c-icon [icon]="icon" color="primary" />
          }
        }
      </div>
    </div>
  </div>

  @if (showError && control?.errors) {
    <div class="error-wrapper">
      <c-validation-error [validationMessages]="control.errors" [controlValue]="control.value"> </c-validation-error>
    </div>
  }
  @if (showError && control?.errors && control?.dirty) {
    <div class="error-wrapper">
      <c-validation-error [validationMessages]="control.errors" [controlValue]="control.value" />
    </div>
  }
</div>


<ion-modal
  [trigger]="readonly ? null : 'open-modal-' + id"
  [breakpoints]="[0, 0.5, 1]"
  [initialBreakpoint]="0.5"
  [handle]="false"
  >
  <ng-template>
    <c-select-modal
      [options]="options"
      [label]="label"
      [enableSearch]="enableSearch"
      [noResultsLabel]="noResultsLabel"
      [selectedValue]="control?.value"
      (select)="onSelect($event)"
      (close)="closeModal()"
      />
  </ng-template>
</ion-modal>
